let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aW7kj")).then(() => parcelRequire('azThA'));